import { Faq, FaqSection } from '@/_shared/models/faq/faq.model';
import Link from 'next/link';

interface AccordionProps {
  items: FaqSection[];
  className?: string;
}

const Accordion = ({ items, className }: AccordionProps) => {
  return (
    <div className={`hs-accordion-group ${className}`}>
      {items.map((item, index) => (
        <div
          className={`hs-accordion mb-5 last:mb-0 ${index == 0 ? 'active' : ''}`}
          id={`hs-basic-heading-${item.id}`}
          key={item.id}
        >
          <button
            className={`border border-gray-200 p-5 hs-accordion-toggle hs-accordion-active:bg-gray-100 flex justify-between items-center gap-x-3 w-full font-semibold text-start text-gray-800 hover:text-gray-500 rounded-lg ${index == 0 ? 'active' : ''}`}
            aria-controls="hs-basic-collapse-one"
          >
            <span>{item.name}</span>

            <svg
              className="hs-accordion-active:hidden block size-3.5"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14"></path>
              <path d="M12 5v14"></path>
            </svg>
            <svg
              className="hs-accordion-active:block hidden size-3.5"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14"></path>
            </svg>
          </button>
          <div
            id={`hs-basic-collapse-${item.id}`}
            className={`hs-accordion-content w-full overflow-hidden transition-[height] duration-300 ${index == 0 ? '' : 'hidden'}`}
            aria-labelledby={`hs-basic-heading-${item.id}`}
          >
            <div className="text-gray-800 dark:text-neutral-200 p-5 flex flex-col gap-5">
              {item.faqs.map((item: Faq, index) => (
                <div key={index}>
                  <h3 className="font-semibold mb-3">{item.question}</h3>
                  <p>{item.answer}</p>
                  {item.link && (
                    <div className="mt-3">
                      <Link
                        className="font-semibold underline hover:text-main-hover transition-all"
                        href={item.link.href}
                      >
                        {item.link.name}
                      </Link>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
